import { combineReducers } from 'redux'

import upload from './upload'

export const reducer = combineReducers({
  upload: upload.reducer,
})

export default reducer
